import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useHashCrypt from '../../helpers/useHashCrypt';
import queryString from 'query-string';
import t from '../../helpers/Translation';
import jwt_decode from "jwt-decode";
import { loginUser } from '../../store/appStore/actions/userActions';
import _ from 'lodash';

import Input from '../../components/form/Input';
import TextIconButton from '../../components/button/TextIconButton';
import Checkbox from '../../components/form/Checkbox';
import * as Styled from "./style";
import * as palette from '../../style/Variables';
import { toast } from 'react-toastify';
import AlertSimple from '../../components/alert/AlertSimple';
import logoSign from '../../img/profil.jpeg';
import logo from '../../img/profil-large.jpeg';
import logoMobile from '../../img/profil-large.jpeg';


const Login = () => {
    const rememberMeStoreState = useSelector(state => state.user.rememberMe.checked)
    const rememberedUsername = useSelector(state => state.user.rememberMe.username)
    const rememberedPassword = useHashCrypt(useSelector(state => state.user.rememberMe.password), false)
    const strings = useSelector(state => state.user.langStrings)
    const userStoreLang = {
        language: useSelector(state => state.user.language),
        languageVersion: useSelector(state => state.user.languageVersion)
    }
    const dispatch = useDispatch()
    const isMounted = useRef(true)
    const formRef = useRef(null)
    const onSubmitRef = useRef(null)

    const [ username, setUsername ] = useState(rememberMeStoreState ? rememberedUsername : '')
    const [ password, setPassword ] = useState(rememberMeStoreState ? rememberedPassword : '')
    const [ rememberMe, setRememberMe ] = useState(rememberMeStoreState)
    const [ errorLine, setErrorLine ] = useState({username: false, password: false})

    // costBook user guest store data
    const costBookUserGuestData = useSelector(state => state.costBook.arhitektiGuestCostBookData)


    // on Enter press listener (calls the latest onSubmit via ref, so it never uses stale state)
    useEffectOnce(() => {
        const onKeyDown = (event) => event.key === "Enter" && isMounted.current && onSubmitRef.current && onSubmitRef.current(event)
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown)
    })


    useEffect(() => {
        return () => {isMounted.current = false}
    }, [])


    const handleChange = (e) => {
        e.target.name === 'username' ? setUsername(e.target.value) : setPassword(e.target.value)
    }

    const handleRememberMe = () => {
        isMounted.current && setRememberMe(!rememberMe)
    }

    const onSubmit = (e) => {
        e.preventDefault()
        // Browser autofill (Chrome/password managers) fills the inputs without firing onChange
        // until the first user interaction, so React state can still be empty on the first click.
        // Read the live DOM values and fall back to state.
        const formEl = formRef.current
        const liveUsername = (formEl && formEl.elements.username && formEl.elements.username.value) || username
        const livePassword = (formEl && formEl.elements.password && formEl.elements.password.value) || password
        if(liveUsername !== username) setUsername(liveUsername)
        if(livePassword !== password) setPassword(livePassword)
        loginUser({username: liveUsername, password: livePassword, rememberMe}, dispatch, actionMsg, userStoreLang)
    }
    onSubmitRef.current = onSubmit

    const actionMsg = (msg) => {
        let msgShow = "Error"
        if(msg === 'USER_DOES_NOT_EXIST') msgShow = "User does not exist!"
        if(msg === 'WRONG_PASSWORD') {
            msgShow = "Wrong password!"
            isMounted.current && setErrorLine({username: false, password: true})
        }
        if(msg === 'TOO_MANY_ATTEMPTS') msgShow = "Too many login attempts, try again in a minute."
        if(msg === 'PANTHEON_UNAVAILABLE') msgShow = "Pantheon is not reachable, try again later."
        toast.error((<AlertSimple icon={palette.x} text={t(msgShow, strings)} />))
    }


    const { costBookId, jwt } = queryString.parse(window.location.search)
    // this hook render only once
	useEffectOnce(() => {
        if(costBookId && jwt ) {
            let decoded = jwt_decode(jwt)
            let authtype = 'jwt'
            let username = decoded.email
            let password = jwt
            let rememberMe = false
            let redirect = '/cost-book-user-guest'
            let costBookUserGuestDataLocal = _.cloneDeep(costBookUserGuestData)
            costBookUserGuestDataLocal.costBookId = costBookId
            dispatch({ type: 'SET_COSTBOOK_GUEST', payload: costBookUserGuestDataLocal })
            loginUser({username, password, rememberMe, authtype, redirect}, dispatch, actionMsg, userStoreLang)
        }
    })



    return(
        <Styled.ContainerWrapper>
            <div className="login_row">

                {/* LOGIN */}
                <div className="login_col_xl_6">
                    <Styled.LogoSignStyle src={ logoSign } />

                    <div>
                        <h1>{t('Login!', strings)}</h1>
                        <form ref={formRef} onSubmit={onSubmit}>
                            <div className="mb-10">
                                <Input
                                    icon={palette.envelope}
                                    type={'text'}
                                    name={'username'}
                                    value={username}
                                    placeholder={t('Username', strings)}
                                    onChange={handleChange}
                                    autoComplete={'username'}
                                    errorBottomLine={errorLine.username}
                                />
                            </div>
                            <Input
                                icon={palette.laLock}
                                type={'password'}
                                name={'password'}
                                value={password}
                                placeholder={t('Password', strings)}
                                onChange={handleChange}
                                autoComplete={'current-password'}
                                errorBottomLine={errorLine.password}
                            />
                            <div className="row remember_box">
                                <div className="col-md-12 text_left text_mobile_center display_inline_block">
                                    <Checkbox
                                        checked={rememberMe}
                                        value={rememberMe}
                                        label={t('Remember me', strings)}
                                        onChange={handleRememberMe}
                                    />
                                </div>
                            </div>
                            <TextIconButton type="submit" actionClick={onSubmit} icon={palette.login} btnText={t('Login', strings)} bgd={'primary'} tooltip={t('Login', strings)}></TextIconButton>
                        </form>
                    </div>
                </div>

                <div className="login_col_xl_6 login_right_side">
                    <Styled.LogoStyle src={ logo } />
                    <Styled.LogoMobileStyle src={ logoMobile } />
                </div>
            </div>
        </Styled.ContainerWrapper>
    )
}


// custom hook
function useEffectOnce(cb) {
    const once = useRef(false)
    useEffect(() => {
        if(!once.current) {
            cb();
            once.current = true
        }

    })
}

export default Login;
